/* global swal, _, angular*/
import './style.less';

export default function($log) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.remove = i => vm.ngModel.splice(i, 1);

  vm.addRadio = () => {
    if (!vm.ngModel) vm.ngModel = [];
    const radio = {
      disabled: false,
      id: `${vm.ngModel.length + 1}_radio`,
      name: undefined,
      required: true
    };
    vm.ngModel.push(angular.copy(radio));
  };

  function activate() {
    $log.debug('Rating Component Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/ratings/input/controller.js